export const menuState = {
  swipeGesture: true,
};
